import styled, { css } from 'styled-components';
import { Row } from '~components';
import { ContainerProps } from './types';

export const Container = styled(Row)<ContainerProps>`
  align-items: center;

  ${({ $hasSpacingDown, $isPrimaryRepresentant }) =>
    $hasSpacingDown &&
    css`
      margin-bottom: ${({ theme }) =>
        theme.spacing[$isPrimaryRepresentant ? 'km10' : 'km6']};
    `}
`;
